import { configureStore } from '@reduxjs/toolkit';
import userDetailsRedcer from './reducer/userDetailReducer';

const store = configureStore({
  reducer: {
    products: userDetailsRedcer,
  },
});

export default store;